import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ClientOperationConfirmationUiRequest {
  confirmationId: number;
  operationType: string;
  amount: number;
  feeAmount?: number;
  taxAmount?: number;
  totalDebitAmount?: number;
  currency: string;
  caissierUsername?: string;
  businessAccountId?: number;
  businessName?: string;
  primaryAccountNumber?: number;
  expiresAt?: string;
}

@Injectable({ providedIn: 'root' })
export class ClientOperationConfirmationUiService {
  private readonly queue: ClientOperationConfirmationUiRequest[] = [];
  private readonly seenConfirmationIds = new Set<number>();
  private readonly activeRequestSubject = new BehaviorSubject<ClientOperationConfirmationUiRequest | null>(null);

  readonly activeRequest$ = this.activeRequestSubject.asObservable();

  enqueue(request: ClientOperationConfirmationUiRequest): void {
    if (!request || !Number.isFinite(request.confirmationId) || request.confirmationId <= 0) {
      return;
    }
    if (this.seenConfirmationIds.has(request.confirmationId)) {
      return;
    }

    this.seenConfirmationIds.add(request.confirmationId);

    if (!this.activeRequestSubject.value) {
      this.activeRequestSubject.next(request);
      return;
    }
    this.queue.push(request);
  }

  completeCurrent(confirmationId: number): void {
    const active = this.activeRequestSubject.value;
    if (active && active.confirmationId === confirmationId) {
      this.activeRequestSubject.next(this.queue.shift() || null);
      return;
    }

    const index = this.queue.findIndex(item => item.confirmationId === confirmationId);
    if (index >= 0) {
      this.queue.splice(index, 1);
    }
  }
}
